import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=292dd544&scoped=true&"
import script from "./multiple.vue?vue&type=script&lang=js&"
export * from "./multiple.vue?vue&type=script&lang=js&"
import style0 from "./multiple.vue?vue&type=style&index=0&id=292dd544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292dd544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/www/xmg-cms-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('292dd544', component.options)
    } else {
      api.reload('292dd544', component.options)
    }
    module.hot.accept("./multiple.vue?vue&type=template&id=292dd544&scoped=true&", function () {
      api.rerender('292dd544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/multiple.vue"
export default component.exports